import {createContext} from 'react';

export type BroadcastContextType = {
    sendMessage: (data: string) => void,
    channel?: BroadcastChannel,
};

export const BroadcastContext = createContext<BroadcastContextType>({
    sendMessage: () => undefined,
});
